'use strict';

angular.module('app').directive('sidebarScroll', function($timeout) {
  return function(scope, elem, attr) {
    $timeout(function() {

      $(document).on('scroll', function() {
        if ($('#overwiev')[0]) {
          var windowWidth = $(window).outerWidth(),
            sliderHeight = $('.start-point').height(),
            containerRightPosition = $('#overwiev').offset().left + $('#overwiev').outerWidth(),
            $this = $(this),
            padding = (windowWidth < 1400) ? 0 : 60,
            paddingInvert = 0, //(windowWidth < 1400) ? 60 : 0,
            paddingRight = (windowWidth < 1400) ? 10 : 0;

          if (windowWidth >= 1400 && windowWidth < 1600) {
            paddingRight = 25;
          }

          if ($this.scrollTop() >  sliderHeight - padding) {
            $(elem).css({
              position: 'fixed',
              top: paddingInvert,
              right: $(window).outerWidth() - containerRightPosition + paddingRight,
              zIndex: ''
            });

            if ($(window).outerWidth() < 1400) {
              $(elem).addClass('active');
            } else {
              $(elem).removeClass('active');
            }
          } else {

            $(elem).css({
              position: '',
              top: '',
              right: ''
            });

            if ($(window).outerWidth() < 1400) {
              $(elem).addClass('active');
            } else {
              $(elem).removeClass('active');
            }
          }

          if ($('.sidebar-finish').length) {
            var mapPosition = $('.sidebar-finish').last().offset().top;

            if ($(elem).height() + $(elem).offset().top > mapPosition) {
              $(elem).css({
                position: '',
                top: mapPosition - $(elem).height() - sliderHeight - 1,
                right: '',
                zIndex: 8
              });

              if ($(window).outerWidth() < 1400) {
                $(elem).removeClass('active');
              }
            }
          }
        }
      });
    }, 300);
  };
})